module.exports = __webpack_public_path__ + "static/sumergible-1975d55f67aaa4a0ee24fb1df4d6172f.png";